import { MouseEvent, useState } from 'react';

import { Button, Skeleton } from '@mui/material';

import first from 'lodash/first';

import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import { TruncatedDisplayText } from '@/components/styled';
import { Avatar } from '@/sections/GlobalHeader/Left/WorkspaceLink/styled';

import { useSelectedTeamId, useTeam, useTeams } from '../../hooks';
import ManagePopover from './ManagePopover';

function TeamMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { teams, loading: teamsLoading } = useTeams();
  const { selectedTeamId, loading, setTeamId } = useSelectedTeamId();

  const { team, loading: teamLoading } = useTeam(selectedTeamId);

  const isLoading = loading || teamLoading || teamsLoading;

  function openManagePopover(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function closeManagePopover() {
    setAnchorEl(null);
  }

  return (
    <>
      <Button
        variant="text"
        color="primary"
        onClick={openManagePopover}
        endIcon={<ChevronDownIcon color="secondary" />}
        sx={{ p: 0.5, userSelect: 'auto', height: 32, gap: 1 }}
        data-cy="team-name"
        disabled={isLoading}
      >
        {!team ? (
          <Skeleton animation="wave" width={120} />
        ) : (
          <>
            <Avatar emoji={!!team.icon}>{team.icon || first(team.name)}</Avatar>
            <TruncatedDisplayText maxWidth={135}>{team.name}</TruncatedDisplayText>
          </>
        )}
      </Button>
      {selectedTeamId && (
        <ManagePopover
          anchorEl={anchorEl}
          teams={teams}
          selectedTeamId={selectedTeamId}
          onClose={closeManagePopover}
          onSelectTeam={setTeamId}
        />
      )}
    </>
  );
}

export default TeamMenu;
